import { useEffect } from 'react';

const useDatePickerClick = (ref, onOpen, onClose) => {
  useEffect(() => {
    const handleOpen = (event) => {
      onOpen(event);
    };

    const handleClose = (event) => {
      onClose(event);
    };

    const current = ref?.current;

    current?.addEventListener('open', handleOpen);
    current?.addEventListener('close', handleClose);
    return () => {
      current?.removeEventListener('open', handleOpen);
      current?.removeEventListener('close', handleClose);
    };
  });
};

export default useDatePickerClick;
